<style lang="scss" scoped>
.btn-warp {
  padding-bottom: 3px;
  text-align: right;
}
.base-warp {
  display: flex;
  padding: 15px;
  .img-warp {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    overflow: hidden;
    text-align: center;
    line-height: 180px;
    cursor: pointer;
  }
  .info-warp {
    flex: 1;
    padding-left: 25px;
    .info {
      margin-top: 15px;
      border-top: 1px solid #dedede;
      padding-top: 20px;
    }
    .top-warp {
      display: flex;
      .lw {
        width: 300px;
      }
      .rw {
        flex: 1;
        display: flex;
        padding-top: 5px;
        .box {
          flex: 1;
          color: #a7a7a7;
          a {
            font-size: 32px;
            font-weight: 600;
            padding: 0 5px;
          }
        }
      }
    }
  }
}
</style>
<style>
</style>
<template>
  <div>
    <Divider orientation="center">会员中心</Divider>
    <div class="base-warp">
      <div class="img-warp" @click="toInfo">
        <Avatar :size="180">{{ userInfo.nickname }}</Avatar>
      </div>
      <div class="info-warp">
        <div class="top-warp">
          <div class="lw">
            <!-- <div style="font-size: 20px">
              <Tag v-if="userInfo.parentUserId">子账户</Tag>
              <Tag v-if="!userInfo.parentUserId" color="primary">主账户</Tag>
              <a @click="toInfo">{{ userInfo.nickname }}</a>
            </div> -->
            <div style="color: #rgb(96, 96, 96); margin-top: 30px">
              <span>邮箱: {{ userInfo.account }} </span>
              <span style="padding: 0 25px"
                >用户名: {{ userInfo.username }}</span
              >
            </div>
            <div style="padding-top: 20px; font-size: larger">
              邀请人数：{{ userInfo.inviteCount }}
            </div>
          </div>
          <div class="rw">
            <div class="box">
              <div class="btn-warp">
                <Button
                  style="text-align: right"
                  class="copy-btn"
                  @click="copyText"
                  size="small"
                  >点击复制</Button
                >
              </div>
              <Input
                show-word-limit
                :rows="3"
                readonly
                type="textarea"
                v-model="userInfo.inviteText"
              />
            </div>
            <div class="box"></div>
          </div>
        </div>

        <div class="info">
          <Row :gutter="8">
            <Col span="5">会员类型</Col>
            <Col span="7">
              <a>{{ isVip ? "VIP会员" : "普通会员" }}</a>
            </Col>
            <Col span="5">VIP会员到期时间</Col>
            <Col span="7">
              <a>
                {{
                  userInfo.memberAccount.replyExpireDateTime
                    ? userInfo.memberAccount.replyExpireDateTime
                    : "永久"
                }}
              </a>
            </Col>
            <!-- <Col span="5">会员组</Col>
            <Col span="7">
              <a>{{ userInfo.memberGroup.name }}</a>
            </Col> -->

            <!-- <Col span="5">语音次数</Col>
            <Col span="7">
              <a>{{ userInfo.memberAccount.usableVoiceNum }}</a>
            </Col> -->
            <!-- <Col v-if="!userInfo.parentUserId" span="5"
              >是否开启字符自动分配</Col
            >
            <Col v-if="!userInfo.parentUserId" span="7">
              <Switch
                v-model="userInfo.autoDistribution"
                :true-value="1"
                :false-value="0"
                @click="autoDistribution(userInfo)"
              />
            </Col> -->
          </Row>
          <Row :gutter="8" style="padding-top: 15px">
            <Col span="5">翻译渠道</Col>
            <Col span="7">
              <translate-channel-label
                :tranChannelId="userInfo.tranChannelId"
              />
              <a
                v-if="!userInfo.parentUserId"
                style="padding: 0 5px"
                @click="openTranChannelMappingModal"
                >切换</a
              >
            </Col>
            <Col span="5">
              <span v-if="userInfo.memberGroup.translationBillingMode == 'char'"
                >字符数量</span
              >
              <span v-if="userInfo.memberGroup.translationBillingMode == 'time'"
                >翻译到期日期</span
              >
            </Col>
            <Col span="7">
              <a v-if="userInfo.memberGroup.translationBillingMode == 'char'">
                {{ userInfo.memberAccount.usableCharNum }}
              </a>
              <a v-if="userInfo.memberGroup.translationBillingMode == 'time'">
                {{ userInfo.memberAccount.expireDate }}
              </a>
            </Col>

            <!-- <Col span="5"> 计费模式 </Col>
            <Col span="7">
              <a v-if="userInfo.memberGroup.translationBillingMode == 'char'">
                字符
              </a>
              <a v-if="userInfo.memberGroup.translationBillingMode == 'time'">
                包月
              </a>
            </Col> -->
          </Row>
          <Row :gutter="8" style="padding-top: 15px">
            <Col span="5">翻译数量</Col>
            <Col span="7">{{ userInfo.memberAccount.usedCharTotal }}</Col>
            <Col span="5">充值金额统计</Col>
            <Col span="7"
              >{{
                (userInfo.memberAccount.rechargeAmountTotal / 100).toFixed(2)
              }}元</Col
            >
          </Row>

          <Row :gutter="8" style="padding-top: 15px">
            <Col span="5">连续登录</Col>
            <Col span="7">
              <a>{{ userInfo.lastLoginLog.sumDay }}天</a>
            </Col>
            <Col span="5">最长连续登录</Col>
            <Col span="7">
              <a>{{ userInfo.lastLoginLog.maxSumDay }}天</a>
            </Col>
          </Row>
          <Row :gutter="8" style="padding-top: 15px">
            <Col span="5">注册时间</Col>
            <Col span="7">{{ userInfo.registerDateTime }}</Col>
            <Col span="5">最后登录</Col>
            <Col span="7">{{ userInfo.lastLoginLog.loginDateTime }}</Col>
          </Row>
        </div>
      </div>
    </div>

    <TranChannelMappingModal
      ref="TranChannelMappingModalRef"
      @on-success="init"
    />
  </div>
</template>

<script>
import ClipboardJS from "clipboard";
import userService from "@/service/user";
import TranslateChannelLabel from "../components/TranslateChannelLabel.vue";
import TranChannelMappingModal from "../components/TranChannelMappingModal.vue";
export default {
  components: { TranslateChannelLabel, TranChannelMappingModal },
  name: "UserCenterIndex",
  data() {
    return {
      userInfo: {
        memberGroup: {},
        memberAccount: {},
        lastLoginLog: {},
        inviteCode: "",
        inviteText: "",
        inviteCount: 0,
      },
      isVip: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.userInfo = await userService.get();
      if (!this.userInfo.memberAccount.replyExpireDateTime) {
        this.isVip = true;
      } else {
        if (
          new Date().getTime() >
          new Date(this.userInfo.memberAccount.replyExpireDateTime)
        ) {
          this.isVip = false;
        } else {
          this.isVip = true;
        }
      }
      this.userInfo.inviteText =
        "电商客服必备工具 / 快捷回复 一键即达，https://www.traneasy.vip/#//?inviteCode=" +
        this.userInfo.inviteCode +
        " 用我的链接注册即可免费使用易回复，并赠送 10000 翻译字符数。";
    },
    toInfo() {
      this.$router.push({ name: "UserCenterInfo" });
    },
    dateHello() {
      // 获取当前时间
      let timeNow = new Date();
      // 获取当前小时
      let hours = timeNow.getHours();
      // 设置默认文字
      let text = ``;
      // 判断当前时间段
      if (hours >= 0 && hours <= 10) {
        text = `早上好`;
      } else if (hours > 10 && hours <= 14) {
        text = `中午好`;
      } else if (hours > 14 && hours <= 18) {
        text = `下午好`;
      } else if (hours > 18 && hours <= 24) {
        text = `晚上好`;
      }
      // 返回当前时间段对应的状态
      return text;
    },
    openTranChannelMappingModal() {
      this.$refs.TranChannelMappingModalRef.open();
    },
    autoDistribution(userInfo) {
      let { userId, autoDistribution } = userInfo;
      let status =
        autoDistribution == 0
          ? '<span style="color:red">禁用</span>'
          : '<span style="color:green">启用</span>';
      let content = "您确定要 [" + status + "] 用户自动分配吗?";
      content += "<br/><small>该操作会同时对所有子账号生效</small>";
      this.$Modal.confirm({
        title: "温馨提示",
        content,
        loading: true,
        onOk: async () => {
          let e = autoDistribution == 0 ? 0 : 1;
          let result = await userService.autoDistribution({
            userId,
            autoDistribution: e,
          });
          this.$Modal.remove();
          if (result) {
            this.$Message.success("成功修改");
            this.loadData();
          }
        },
      });
    },
    copyText() {
      const text = this.userInfo.inviteText;
      const clipboard = new ClipboardJS(".btn", {
        text: () => text,
      });

      clipboard.on("success", () => {
        alert("已复制");
        clipboard.destroy();
      });

      clipboard.on("error", () => {
        alert("复制失败");
        clipboard.destroy();
      });

      clipboard.onClick(event);
    },
  },
};
</script>

